import { useQuery } from '@tanstack/react-query'
import { getWorkExperienceFormOptions } from 'api/user'

export function useWorkExperienceFormOptions() {
  return useQuery({
    queryKey: ['workExperienceFormOptions'],
    queryFn: getWorkExperienceFormOptions,
  })
}
